/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_New_OnlyInputs */

const en_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Voice Only`)
};

const fr_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle voix uniquement`)
};

const de_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur neue Stimme`)
};

const it_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo nuova voce`)
};

const ru_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только новый голос`)
};

const es_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo nueva voz`)
};

const zh_cn2_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新语音`)
};

const ja_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい音声のみ`)
};

const hi_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल नई आवाज`)
};

const pt_pt2_options_editor_speaker_assignment_new_only = /** @type {(inputs: Options_Editor_Speaker_Assignment_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente novas vozes`)
};

/**
* | output |
* | --- |
* | "New Voice Only" |
*
* @param {Options_Editor_Speaker_Assignment_New_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_new_only = /** @type {((inputs?: Options_Editor_Speaker_Assignment_New_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_New_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "de") return de_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "it") return it_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "ru") return ru_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "es") return es_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "ja") return ja_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "hi") return hi_options_editor_speaker_assignment_new_only(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_speaker_assignment_new_only(inputs)
	return en_options_editor_speaker_assignment_new_only(inputs)
});